import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import type { RoleCardRole } from '../../types';
import { SystemRoleCard } from './SystemRoleCard';

type SystemRoleCardGridProps = {
  roles: RoleCardRole[];
  userRoleName: string;
  showUsersCount: boolean;
  onView: (role: RoleCardRole) => void;
};

export function SystemRoleCardGrid({
  roles,
  userRoleName,
  showUsersCount,
  onView,
}: SystemRoleCardGridProps) {
  const { t } = useTranslation('authorization');

  if (roles.length === 0) {
    return (
      <Empty
        className="authorization-empty-state"
        description={t('roleCard.empty')}
      />
    );
  }

  return (
    <div className="authorization-system-role-grid">
      {roles.map((role) => (
        <SystemRoleCard
          key={role.id}
          role={role}
          userRoleName={userRoleName}
          showUsersCount={showUsersCount}
          onView={onView}
        />
      ))}
    </div>
  );
}
